import { menus } from 'constants/menu.constants';
import { action } from 'easy-peasy';

export const headerModel = {
  menus,
  menuSelected: menus[0],
  changeMenu: action((state, payload) => {
    state.menuSelected = payload;
  })
};